/** Country of residence: the full ISO list, named in the reader's language (D-110). */

import { countryOptions } from "@agencyos/core";
import { SelectField } from "@agencyos/ui-web";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function CountrySelect({
  value,
  onChange,
  error,
  hint,
  label,
}: {
  value: string;
  onChange: (code: string) => void;
  error?: string;
  hint?: string;
  label?: string;
}) {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? "fr";
  const options = useMemo(() => countryOptions(language), [language]);
  return (
    <SelectField
      label={label ?? t("academySales.signup.country")}
      hint={hint}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={error}
      autoComplete="country"
      options={[{ value: "", label: t("academySales.signup.chooseCountry") }, ...options]}
    />
  );
}
